(function () {
  const el = window.UIDOM.el;
  const esc = window.UIDOM.esc;
  const RB = window.RB;
  const U = window.UIX;
  const pct = U.pct;
  const cardName = U.cardName;
  const MENU_KEY = "riftbound-menu-cfg";
  const START_KEY = "riftbound-trainer-start";
  const SPAR_KEY = "riftbound-trainer-spar";
  const LAB_KEY = "riftbound-trainer-lab";
  const PILOTS = ["greedy", "random", "ismcts:100", "ismcts:400"];
  const POLL_MS = 1500;

  const S = {
    root: null,
    booted: false,
    fields: null,
    fieldId: null,
    field: null,
    results: { matrix: null, swiss: null, search: null },
    loaded: { matrix: null, swiss: null, search: null },
    tuned: {},
    jobs: null,
    timer: null,
    jobsNode: null,
    err: null,
    cfg: { pilot: "greedy", games: 200, runs: 2000, iters: 20, searchGames: 100, legend: "", gens: 30, tuneGames: 2000, tuned: false },
  };

  function save() {
    try { localStorage.setItem(LAB_KEY, JSON.stringify({ fieldId: S.fieldId, cfg: S.cfg })); } catch (e) { }
  }

  function restore() {
    try {
      const raw = JSON.parse(localStorage.getItem(LAB_KEY) || "null");
      if (raw && raw.cfg) Object.assign(S.cfg, raw.cfg);
      if (raw && raw.fieldId) S.fieldId = raw.fieldId;
    } catch (e) { }
  }

  function artImg(id, cls, sizes) {
    return U.artImg(id, cls, { sizes: sizes, lazy: false, animated: false });
  }

  function get(url, cb) {
    RB.Api.get(url).then(cb).catch(function (e) {
      S.err = "Could not load " + url + ": " + e.message;
      render();
    });
  }

  function post(url, body, cb) {
    RB.Api.post(url, body)
      .then(function (r) {
        if (!r.ok) { S.err = (r.body && r.body.error) || "request failed"; render(); return; }
        cb(r.body);
      })
      .catch(function (e) { S.err = e.message; render(); });
  }

  function newestFor(entries, fieldId) {
    for (const e of entries || []) if (e.meta && e.meta.field === fieldId) return e;
    return null;
  }

  function loadResults() {
    get("/api/meta/tuned", function (rows) {
      S.tuned = {};
      for (const r of Array.isArray(rows) ? rows : []) if (r && r.id && !r.error) S.tuned[r.id] = r.meta || {};
      render();
    });
    for (const kind of ["matrix", "swiss", "search"]) {
      (function (kind) {
        get("/api/meta/" + kind, function (entries) {
          S.results[kind] = entries;
          const hit = newestFor(entries, S.fieldId);
          if (!hit) { S.loaded[kind] = null; render(); return; }
          get("/api/meta/" + kind + "/" + encodeURIComponent(hit.file), function (obj) {
            S.loaded[kind] = obj;
            render();
          });
        });
      })(kind);
    }
  }

  function selectField(id) {
    S.fieldId = id;
    S.field = null;
    S.loaded = { matrix: null, swiss: null, search: null };
    S.cfg.legend = "";
    save();
    render();
    get("/api/meta/field/" + encodeURIComponent(id), function (f) {
      S.field = f;
      render();
    });
    loadResults();
  }

  function pollJobs() {
    get("/api/meta/jobs", function (j) {
      const wasRunning = !!(S.jobs && S.jobs.running);
      S.jobs = j;
      if (j.running && !S.timer) S.timer = setInterval(pollJobs, POLL_MS);
      if (!j.running && S.timer) { clearInterval(S.timer); S.timer = null; }
      if (wasRunning && !j.running) loadResults();
      const stale = S.jobsNode;
      if (wasRunning === !!j.running && stale && stale.parentNode) {
        stale.parentNode.replaceChild(jobsPanel(), stale);
        return;
      }
      render();
    });
  }

  function startJob(body) {
    S.err = null;
    post("/api/meta/jobs", body, function () { pollJobs(); });
  }

  function weightOf(list) {
    return typeof list.weight === "number" ? list.weight : 0;
  }

  function legendShares() {
    const f = S.field;
    if (!f) return [];
    const shares = {};
    if (f.legendShares && Object.keys(f.legendShares).length) {
      for (const id in f.legendShares) shares[id] = { share: f.legendShares[id], lists: 0 };
    }
    for (const l of f.lists || []) {
      if (!shares[l.legend]) shares[l.legend] = { share: 0, lists: 0, derived: true };
      shares[l.legend].lists++;
      if (shares[l.legend].derived) shares[l.legend].share += weightOf(l);
    }
    const rows = Object.keys(shares).map(function (id) {
      return { legend: id, share: shares[id].share, lists: shares[id].lists };
    });
    const total = rows.reduce(function (a, r) { return a + r.share; }, 0) || 1;
    for (const r of rows) r.norm = r.share / total;
    rows.sort(function (a, b) { return b.share - a.share; });
    return rows;
  }

  function listDeck(list) {
    return {
      id: "meta-" + list.id,
      name: list.name || list.id,
      legend: list.legend,
      champion: list.champion,
      battlefields: (list.battlefields || []).slice(),
      runes: Object.assign({}, list.runes || {}),
      deck: (list.deck || []).slice(),
    };
  }

  function storeDeck(deck) {
    const errs = RB.Decklists.validate(deck);
    if (errs.length) {
      S.err = deck.name + " is not a legal deck: " + errs.join("; ");
      render();
      return null;
    }
    RB.Decklists.saveCustom(deck);
    return deck;
  }

  function openInBuilder(deck) {
    if (!storeDeck(deck)) return;
    location.href = "/deckbuilder/" + encodeURIComponent(deck.id);
  }

  function useInSparring(deck) {
    if (!storeDeck(deck)) return;
    let spar = { native: "pg-yi", strength: "normal" };
    try { Object.assign(spar, JSON.parse(localStorage.getItem(SPAR_KEY) || "null") || {}); } catch (e) { }
    const bot = RB.Decklists.get(spar.native) ? spar.native : (RB.Decklists.all()[0] || {}).id;
    const you = { deck: deck.id, ai: false };
    const native = { deck: bot, ai: "native:" + (spar.strength || "normal") };
    try {
      localStorage.setItem(MENU_KEY, JSON.stringify({ seats: [you, native], foe: "native", strength: spar.strength || "normal" }));
      localStorage.setItem(START_KEY, "1");
    } catch (e) { }
    location.href = "/play";
  }

  function section(title, sub) {
    return U.sectionHead("labhead", title, sub, "mslbl trmuted");
  }

  function fieldPicker() {
    const bar = el("div", "labfields");
    for (const f of S.fields) {
      (function (f) {
        const b = el("button", "btn" + (f.id === S.fieldId ? " on" : ""), esc(f.name || f.id));
        b.onclick = function () { selectField(f.id); };
        bar.appendChild(b);
      })(f);
    }
    return bar;
  }

  function fieldSummary() {
    const f = S.field;
    const win = f.window || {};
    const box = el("div", "labsum");
    const bits = [
      ["Format", f.format || "—"],
      ["Window", (win.from || "?") + " → " + (win.to || "?")],
      ["Lists", String((f.lists || []).length)],
      ["Swiss", f.swiss ? f.swiss.players + " players · " + f.swiss.rounds + " rounds · top " + f.swiss.cut : "—"],
      ["Match", (f.match && f.match.format) || "bo1"],
    ];
    for (const b of bits) {
      const cell = el("div", "labstat");
      cell.appendChild(el("span", "mslbl", esc(b[0])));
      cell.appendChild(el("span", "labstatv msnum", esc(b[1])));
      box.appendChild(cell);
    }
    return box;
  }

  const SHARE_ROWS = 16;

  function sharesPanel() {
    const all = legendShares();
    const rows = all.slice(0, SHARE_ROWS);
    const wrap = el("div", "labshares");
    for (const r of rows) {
      const row = el("div", "labshare");
      row.appendChild(artImg(r.legend, "labface", "80px"));
      const body = el("div", "labsharebody");
      const top = el("div", "labsharetop");
      top.appendChild(el("span", "labsharename", esc(cardName(r.legend))));
      top.appendChild(el("span", "msnum labsharepct", esc(pct(r.share))));
      body.appendChild(top);
      const track = el("div", "labtrack");
      const fill = el("div", "labfill");
      fill.style.width = Math.max(1.5, r.norm * 100) + "%";
      track.appendChild(fill);
      body.appendChild(track);
      body.appendChild(el("div", "mslbl trmuted", r.lists + (r.lists === 1 ? " list" : " lists")));
      row.appendChild(body);
      wrap.appendChild(row);
    }
    if (!rows.length) wrap.appendChild(el("div", "msempty", "This field has no legend shares."));
    if (all.length > rows.length) {
      const rest = all.slice(rows.length);
      const tail = rest.reduce(function (a, r) { return a + r.share; }, 0);
      wrap.appendChild(el("div", "mslbl trmuted",
        esc("+ " + rest.length + " more legends below " + pct(rows[rows.length - 1].share) + ", " + pct(tail) + " of the field between them")));
    }
    return wrap;
  }

  function listsPanel() {
    const wrap = el("div", "lablists");
    for (const l of S.field.lists || []) {
      const row = el("div", "lablist");
      row.appendChild(artImg(l.legend, "labface", "80px"));
      const body = el("div", "lablistbody");
      body.appendChild(el("div", "lablistname", esc(cardName(l.legend)) + " · " + esc(cardName(l.champion))));
      const ev = l.event || {};
      const meta = [ev.name, ev.placement ? "#" + ev.placement : null, ev.date, ev.players ? ev.players + " players" : null]
        .filter(Boolean).join(" · ");
      body.appendChild(el("div", "mslbl trmuted", esc(meta || l.id)));
      if (l.missing) body.appendChild(el("div", "menuerr", "list file is missing"));
      if (S.tuned[l.id]) body.appendChild(el("div", "mslbl labtuned", esc(tunedLabel(S.tuned[l.id]))));
      row.appendChild(body);
      const share = el("div", "labshareval msnum", esc(pct(weightOf(l))));
      share.title = "share of the field";
      row.appendChild(share);
      const acts = el("div", "labacts");
      if (!l.missing) {
        const spar = el("button", "btn small", "Use in sparring");
        spar.onclick = function () { useInSparring(listDeck(l)); };
        acts.appendChild(spar);
        const build = el("button", "btn small ghost", "Open in builder");
        build.onclick = function () { openInBuilder(listDeck(l)); };
        acts.appendChild(build);
        const tune = el("button", "btn small ghost", S.tuned[l.id] ? "Re-tune" : "Tune");
        tune.disabled = !!(S.jobs && S.jobs.running);
        tune.title = "tune this list's evaluation weights against the field (" + S.cfg.gens + " generations, " + S.cfg.tuneGames + " games each)";
        tune.onclick = function () {
          startJob({ kind: "tune", field: S.fieldId, list: l.id, pilot: S.cfg.pilot, gens: S.cfg.gens, games: S.cfg.tuneGames });
        };
        acts.appendChild(tune);
      }
      row.appendChild(acts);
      wrap.appendChild(row);
    }
    return wrap;
  }

  function tunedLabel(meta) {
    const v = meta && meta.verify;
    const bits = ["tuned"];
    if (meta && meta.field) bits.push("vs " + meta.field);
    if (v && v.field) bits.push("held-out " + pct(v.field.aRate) + " vs " + pct(v.field.bRate) + " (paired " + v.field.aWins + "-" + v.field.bWins + ")");
    if (v && v.mirror) bits.push("mirror " + pct(v.mirror.aRate));
    return bits.join(" · ");
  }

  function weightsById() {
    const out = {};
    let sum = 0;
    for (const l of (S.field && S.field.lists) || []) { out[l.id] = weightOf(l); sum += weightOf(l); }
    if (sum > 0) for (const id in out) out[id] /= sum;
    return out;
  }

  function fieldWinrates(m) {
    const w = weightsById();
    return m.lists.map(function (id, i) {
      let wr = 0;
      let tot = 0;
      for (const other in w) {
        const j = m.lists.indexOf(other);
        if (j < 0) continue;
        tot += w[other];
        wr += w[other] * m.wins[i][j];
      }
      return tot ? wr / tot : 0.5;
    });
  }

  function heatStyle(p, n) {
    if (!n) return "background: rgba(255,255,255,.03); color: var(--faint)";
    const d = Math.max(-1, Math.min(1, (p - 0.5) * 2));
    const a = (0.10 + Math.abs(d) * 0.45).toFixed(3);
    const rgb = d >= 0 ? "70, 209, 131" : "228, 87, 74";
    return "background: rgba(" + rgb + ", " + a + ")";
  }

  function matrixPanel() {
    const m = S.loaded.matrix;
    if (!m) return el("div", "msempty", "No matrix yet — run one below.");
    const wrs = fieldWinrates(m);
    const order = m.lists.map(function (id, i) { return i; })
      .sort(function (a, b) { return wrs[b] - wrs[a]; });
    const scroll = el("div", "labscroll");
    const table = el("table", "labmatrix");
    const head = document.createElement("tr");
    head.appendChild(el("th", "labcorner", "vs →"));
    for (const j of order) {
      const th = document.createElement("th");
      th.className = "labcol";
      th.title = cardName(listLegend(m.lists[j])) + " — " + m.lists[j];
      th.appendChild(artImg(listLegend(m.lists[j]), "labchip", "48px"));
      head.appendChild(th);
    }
    const fw = el("th", "labcol labfw", "field");
    head.appendChild(fw);
    table.appendChild(head);
    for (const i of order) {
      const tr = document.createElement("tr");
      const name = el("th", "labrow");
      name.appendChild(artImg(listLegend(m.lists[i]), "labchip", "48px"));
      name.appendChild(el("span", null, esc(cardName(listLegend(m.lists[i])))));
      name.title = m.lists[i];
      tr.appendChild(name);
      for (const j of order) {
        tr.appendChild(U.matrixCell(m, i, j, "labcell" + (i === j ? " labdiag" : ""), function (p, n, diag) {
          return diag ? "background: rgba(255,255,255,.04); color: var(--faint)" : heatStyle(p, n);
        }, listLegend));
      }
      const wcell = el("td", "labcell labfw msnum", pct(wrs[i]));
      wcell.setAttribute("style", heatStyle(wrs[i], 1));
      wcell.title = "field-weighted win rate";
      tr.appendChild(wcell);
      table.appendChild(tr);
    }
    scroll.appendChild(table);
    const box = el("div", "labblock");
    box.appendChild(scroll);
    if (m.meta) {
      const tuned = Array.isArray(m.meta.tuned) ? m.meta.tuned.length : 0;
      box.appendChild(el("div", "mslbl trmuted",
        esc(m.meta.pilot + " · " + m.meta.games + " games per cell · " + (tuned ? tuned + " tuned lists · " : "") +
          (m.meta.durationMs / 1000).toFixed(1) + "s · " + String(m.meta.createdAt).slice(0, 16).replace("T", " "))));
    }
    return box;
  }

  function listLegend(id) {
    for (const l of (S.field && S.field.lists) || []) if (l.id === id) return l.legend;
    return id;
  }

  function swissPanel() {
    const s = S.loaded.swiss;
    if (!s) return el("div", "msempty", "No Swiss simulation yet — run the matrix, then Swiss.");
    const cut = (s.swiss && s.swiss.cut) || 8;
    const scroll = el("div", "labscroll");
    const table = el("table", "labtable");
    const head = document.createElement("tr");
    for (const h of ["Deck", "Share", "Field WR", "E[wins]", "P(top " + cut + ")", "P(win)"]) {
      head.appendChild(el("th", null, esc(h)));
    }
    table.appendChild(head);
    for (const r of s.rows) {
      const tr = document.createElement("tr");
      const nameCell = document.createElement("td");
      nameCell.className = "labname";
      nameCell.appendChild(artImg(listLegend(r.list), "labchip", "48px"));
      nameCell.appendChild(el("span", null, esc(cardName(listLegend(r.list)))));
      nameCell.title = r.list;
      tr.appendChild(nameCell);
      tr.appendChild(el("td", "msnum", esc(pct(r.share))));
      tr.appendChild(el("td", "msnum", esc(pct(r.fieldWinrate))));
      tr.appendChild(el("td", "msnum", esc(r.expectedWins.toFixed(2))));
      tr.appendChild(el("td", "msnum", esc(pct(r.pCut))));
      tr.appendChild(el("td", "msnum", esc(pct(r.pWin, 2))));
      table.appendChild(tr);
    }
    scroll.appendChild(table);
    const box = el("div", "labblock");
    box.appendChild(scroll);
    if (s.meta) {
      box.appendChild(el("div", "mslbl trmuted",
        esc(s.meta.runs + " simulated events · matrix " + s.meta.pilot + " · " +
          String(s.meta.createdAt).slice(0, 16).replace("T", " "))));
    }
    return box;
  }

  function searchPanel() {
    const r = S.loaded.search;
    const box = el("div", "labblock");
    if (!r) {
      box.appendChild(el("div", "msempty", "No deck search for this field yet — pick a legend below and run one."));
      return box;
    }
    const top = el("div", "labbest");
    top.appendChild(artImg(r.meta.legend, "labbestart", "180px"));
    const body = el("div", "labbestbody");
    body.appendChild(el("div", "labbesttitle", esc(cardName(r.meta.legend))));
    const gain = r.best.winrate - r.start.winrate;
    body.appendChild(el("div", "labbestwr msnum",
      pct(r.best.winrate) + " <span class='labci'>[" + pct(r.best.lo) + ", " + pct(r.best.hi) + "]</span>"));
    body.appendChild(el("div", "mslbl trmuted",
      esc("field win rate · from " + pct(r.start.winrate) + " (" + (gain >= 0 ? "+" : "") + pct(gain) + ") · " +
        r.meta.iters + " swaps · " + r.meta.games + " games per opponent · " + r.meta.pilot)));
    if (r.changes && r.changes.length) {
      const chips = el("div", "labchanges");
      for (const c of r.changes) {
        const d = c.to - c.from;
        chips.appendChild(el("span", "labchg " + (d > 0 ? "up" : "down"),
          (d > 0 ? "+" : "") + d + " " + esc(c.name)));
      }
      body.appendChild(chips);
    }
    const acts = el("div", "labacts");
    const spar = el("button", "btn small", "Use in sparring");
    spar.onclick = function () { useInSparring(Object.assign({}, r.best.deck)); };
    acts.appendChild(spar);
    const build = el("button", "btn small ghost", "Open in builder");
    build.onclick = function () { openInBuilder(Object.assign({}, r.best.deck)); };
    acts.appendChild(build);
    body.appendChild(acts);
    top.appendChild(body);
    box.appendChild(top);
    const per = el("div", "labper");
    for (const p of r.best.perOpponent || []) {
      const row = el("div", "labperrow");
      row.appendChild(artImg(listLegend(p.list), "labchip", "48px"));
      row.appendChild(el("span", "labpername", esc(cardName(listLegend(p.list)))));
      const track = el("div", "labtrack");
      const fill = el("div", "labfill");
      fill.style.width = Math.max(1.5, p.p * 100) + "%";
      fill.setAttribute("style", fill.getAttribute("style") + ";" + heatStyle(p.p, p.n));
      track.appendChild(fill);
      row.appendChild(track);
      const v = el("span", "msnum labperval", pct(p.p));
      v.title = p.n + " games";
      row.appendChild(v);
      per.appendChild(row);
    }
    box.appendChild(per);
    return box;
  }

  function numInput(value, min, max, onChange) {
    const inp = document.createElement("input");
    inp.type = "number";
    inp.className = "labnum";
    inp.value = String(value);
    inp.min = String(min);
    inp.max = String(max);
    inp.onchange = function () {
      const n = Math.max(min, Math.min(max, Number(inp.value) || min));
      inp.value = String(n);
      onChange(n);
    };
    return inp;
  }

  function labField(label, control) {
    const f = el("div", "trfield");
    f.appendChild(el("span", "mslbl", esc(label)));
    f.appendChild(control);
    return f;
  }

  function legendSelect() {
    const sel = document.createElement("select");
    const seen = {};
    let html = "<option value=''>— pick a legend —</option>";
    for (const l of (S.field && S.field.lists) || []) {
      if (seen[l.legend]) continue;
      seen[l.legend] = true;
      html += "<option value='" + esc(l.legend) + "'>" + esc(cardName(l.legend)) + "</option>";
    }
    sel.innerHTML = html;
    sel.value = S.cfg.legend || "";
    sel.onchange = function () { S.cfg.legend = sel.value; save(); render(); };
    return sel;
  }

  function runPanel() {
    const busy = !!(S.jobs && S.jobs.running);
    const panel = el("div", "labrun");
    const grid = el("div", "trgrid");
    const pilot = document.createElement("select");
    pilot.innerHTML = PILOTS.map(function (p) {
      return "<option value='" + p + "'" + (p === S.cfg.pilot ? " selected" : "") + ">" + p + "</option>";
    }).join("");
    pilot.value = S.cfg.pilot;
    pilot.onchange = function () { S.cfg.pilot = pilot.value; save(); render(); };
    grid.appendChild(labField("Pilot", pilot));
    grid.appendChild(labField("Games per cell", numInput(S.cfg.games, 2, 2000, function (n) { S.cfg.games = n; save(); })));
    grid.appendChild(labField("Swiss runs", numInput(S.cfg.runs, 100, 50000, function (n) { S.cfg.runs = n; save(); })));
    grid.appendChild(labField("Search legend", legendSelect()));
    grid.appendChild(labField("Search swaps", numInput(S.cfg.iters, 1, 300, function (n) { S.cfg.iters = n; save(); })));
    grid.appendChild(labField("Search games", numInput(S.cfg.searchGames, 2, 2000, function (n) { S.cfg.searchGames = n; save(); })));
    grid.appendChild(labField("Tune generations", numInput(S.cfg.gens, 1, 200, function (n) { S.cfg.gens = n; save(); })));
    grid.appendChild(labField("Tune games", numInput(S.cfg.tuneGames, 2, 10000, function (n) { S.cfg.tuneGames = n; save(); })));
    const tunedBox = document.createElement("input");
    tunedBox.type = "checkbox";
    tunedBox.checked = !!S.cfg.tuned;
    tunedBox.onchange = function () { S.cfg.tuned = tunedBox.checked; save(); };
    tunedBox.title = "lists with tuned weights play with them in the matrix";
    grid.appendChild(labField("Matrix uses tuned weights", tunedBox));
    panel.appendChild(grid);
    const acts = el("div", "labacts");
    const mx = el("button", "btn primary", "Run matrix");
    mx.disabled = busy;
    mx.onclick = function () {
      startJob({ kind: "matrix", field: S.fieldId, pilot: S.cfg.pilot, games: S.cfg.games, tuned: !!S.cfg.tuned });
    };
    acts.appendChild(mx);
    const sw = el("button", "btn", "Run Swiss");
    sw.disabled = busy || !S.loaded.matrix;
    sw.onclick = function () {
      startJob({ kind: "swiss", field: S.fieldId, pilot: S.cfg.pilot, runs: S.cfg.runs });
    };
    acts.appendChild(sw);
    const se = el("button", "btn", "Run deck search");
    se.disabled = busy || !S.cfg.legend;
    se.onclick = function () {
      startJob({
        kind: "search", field: S.fieldId, pilot: S.cfg.pilot,
        legend: S.cfg.legend, games: S.cfg.searchGames, iters: S.cfg.iters,
      });
    };
    acts.appendChild(se);
    panel.appendChild(acts);
    panel.appendChild(jobsPanel());
    return panel;
  }

  function jobsPanel() {
    const wrap = el("div", "labjobs");
    S.jobsNode = wrap;
    const jobs = (S.jobs && S.jobs.jobs) || [];
    if (!jobs.length) {
      wrap.appendChild(el("div", "mslbl trmuted", "No jobs run yet this session."));
      return wrap;
    }
    for (const j of jobs.slice(0, 4)) {
      const row = el("div", "labjob " + j.status);
      const head = el("div", "labjobhead");
      head.appendChild(el("span", "labjobkind", esc(j.kind)));
      head.appendChild(el("span", "mslbl trmuted", esc(j.field + " · " + j.pilot + (j.legend ? " · " + cardName(j.legend) : "") +
        (j.list ? " · " + cardName(listLegend(j.list)) + " (" + j.list + ")" : "") + (j.tuned ? " · tuned" : ""))));
      head.appendChild(el("span", "labjobstatus " + j.status, esc(j.status)));
      row.appendChild(head);
      if (j.progress) row.appendChild(el("div", "labjobprog msnum", esc(j.progress)));
      if (j.error) row.appendChild(el("div", "menuerr", esc(j.error)));
      else if (j.status !== "running" && j.lines.length) {
        row.appendChild(el("div", "mslbl trmuted", esc(j.lines[j.lines.length - 1])));
      }
      wrap.appendChild(row);
    }
    return wrap;
  }

  function render() {
    const root = S.root;
    if (!root) return;
    root.innerHTML = "";
    root.className = "lab";
    if (S.err) {
      const bad = el("div", "menuerr", "⚠ " + esc(S.err));
      bad.onclick = function () { S.err = null; render(); };
      root.appendChild(bad);
    }
    if (S.fields === null) {
      root.appendChild(el("div", "mslbl", "Loading fields…"));
      return;
    }
    if (!S.fields.length) {
      root.appendChild(el("div", "msempty",
        "No metagame fields yet. Import lists with tools/meta_field.js import, then build one with tools/meta_field.js build."));
      return;
    }
    root.appendChild(fieldPicker());
    if (!S.field) {
      root.appendChild(el("div", "mslbl", "Loading field…"));
      return;
    }
    root.appendChild(fieldSummary());
    root.appendChild(section("Legend shares", "who is playing what, weighted by placement and recency"));
    root.appendChild(sharesPanel());
    root.appendChild(section("Lists", (S.field.lists || []).length + " decks in the field"));
    root.appendChild(listsPanel());
    root.appendChild(section("Matchup matrix", "rows sorted by field-weighted win rate · hover a cell for the interval"));
    root.appendChild(matrixPanel());
    root.appendChild(section("Swiss simulation", "expected finish over a simulated event"));
    root.appendChild(swissPanel());
    root.appendChild(section("Best deck for this field", "local search over card swaps inside the legend's pool"));
    root.appendChild(searchPanel());
    root.appendChild(section("Run", "the C++ self-play engine drives every number above"));
    root.appendChild(runPanel());
  }

  window.RB.TrainerLab = {
    render(container) {
      S.root = container;
      if (!S.booted) {
        S.booted = true;
        restore();
        get("/api/meta/fields", function (fields) {
          S.fields = Array.isArray(fields) ? fields : [];
          const want = S.fields.some(function (f) { return f.id === S.fieldId; }) ? S.fieldId : (S.fields[0] || {}).id;
          if (want) selectField(want);
          else render();
        });
        pollJobs();
      }
      render();
    },
  };
})();
